module.exports = __webpack_public_path__ + "static/img/serviceP5.bb6bbb5e.png";